import { render, staticRenderFns } from "./NotificationUpdateCard.vue?vue&type=template&id=64fb0fe9&scoped=true"
import script from "./NotificationUpdateCard.vue?vue&type=script&lang=js"
export * from "./NotificationUpdateCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationUpdateCard.vue?vue&type=style&index=0&id=64fb0fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb0fe9",
  null
  
)

export default component.exports